// Import the sprite via Vite so it ships with a content-hashed URL
// (e.g. /assets/icons-DEADBEEF.svg). Without this, the previous
// `public/icons.svg` lived under a stable URL and Cloudflare's edge
// happily cached it forever — newly-added symbols (i-trash, i-chevron-left,
// i-close) never reached browsers even after the deploy completed.
// The hashed URL changes on every content change, so cache invalidates
// automatically.
import spriteUrl from '../icons.svg';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 16, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      // Every sprite symbol is authored at 0 0 24 24. Without viewBox on the
      // outer <svg>, browsers render the <use>-referenced content at its
      // native 24x24 anchored top-left and clip to size×size — symbols whose
      // strokes start far from (0,0) (trash's lid is around y=4, chevrons sit
      // around y=6..18) end up clipped to nothing, even though larger
      // symbols (plus, lines that pass through the centre) appear to work
      // fine. The symptom looks identical to the iOS Safari sprite quirk
      // but actually hits every browser; adding viewBox is the one-line fix.
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <use href={`${spriteUrl}#${name}`} />
    </svg>
  );
}
